module.exports = __webpack_public_path__ + "images/refresh55b470acb148da1533d6c257af319a78.svg";